import { SET_PAGE } from '../constants/actionTypes';

const initialState = {
    page: ""
};

const nav = (state = initialState, action) => {
    switch(action.type) {
        case SET_PAGE:
            return {
                ...state,
                page: action.page
            };

        default:
            return state;
    }
};

export default nav;



// WEBPACK FOOTER //
// ./src/reducers/nav.js